<template>
  <component :is="currentLayout">
    <template #default>
      <component :is="currentSplash"      v-if="activePage === 'splash'" />
      <BookingPage                        v-else-if="activePage === 'booking'" />
      <component :is="currentOrder"       v-else-if="activePage === 'order'" />
      <component :is="currentOrders"      v-else-if="activePage === 'orders_history'" />
      <component :is="currentOrderDetail" v-else-if="activePage === 'order_detail'" />
      <div v-else></div>
    </template>
    <template #dialogs>
      <Auth                 v-if="$store.state.loginDialogStatus"/>
      <SubmitBookingPage     v-if="$store.state.bookingDialogStatus"/>
      <BookingSelectEmploye  v-if="$store.state.bookingSelectEmployeDialogStatus"/>
      <BookingSelectService  v-if="$store.state.bookingSelectServiceDialogStatus"/>
      <CartComponent         v-if="$store.state.showCartDialogStatus"/>
    </template>
  </component>
</template>

<script>
// صفحات پیش‌فرض (fallback وقتی تم override نداره)
import DefaultSplash       from './pages/splash.vue';
import DefaultOrder        from './pages/order.vue';
import DefaultOrders       from './pages/orders.vue';
import DefaultOrderDetail  from './pages/order_detail.vue';
import DefaultLayout       from './themes/default/Layout.vue';

import BookingPage from './pages/booking.vue';

// dialogs
import SubmitBookingPage   from './components/submit_booking.vue';
import BookingSelectEmploye from './components/booking_select_employe.vue';
import BookingSelectService from './components/booking_select_service.vue';
import CartComponent       from './components/cart.vue';
import Auth                from './components/auth.vue';

export default {
  name: 'App',
  components: {
    Auth,
    SubmitBookingPage,
    BookingSelectEmploye,
    BookingSelectService,
    BookingPage,
    CartComponent,
    DefaultSplash, DefaultOrder, DefaultOrders, DefaultOrderDetail, DefaultLayout,
  },
  computed: {
    activePage()        { return this.$store.state.activePage; },
    theme()             { return this.$store.state.currentTheme; },
    currentLayout()      { return this.theme?.Layout       ?? DefaultLayout; },
    currentSplash()       { return this.theme?.pages?.Splash      ?? DefaultSplash; },
    currentOrder()        { return this.theme?.pages?.Order       ?? DefaultOrder; },
    currentOrders()       { return this.theme?.pages?.Orders      ?? DefaultOrders; },
    currentOrderDetail()  { return this.theme?.pages?.OrderDetail ?? DefaultOrderDetail; },
  },
  async mounted() {
    await this.$store.dispatch('fetchAuthToken');
    await this.$store.dispatch('fetchBaseData');

    if (this.$route.query.table) {
      this.$store.commit('setTableNumber', this.$route.query.table);
    }
  },
};
</script>

<style>
.Vue-Toastification__toast-body{
  font-family: 'iransans' !important;
  direction: rtl;
}

.main-bg-color{
  background: linear-gradient(135deg, #ffffff, rgb(233, 230, 233));
}

.global-card-background {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
